module.exports = __webpack_public_path__ + "static/img/coupons-bg.0fa584b6.png";